import { StyleSheet } from "react-native";
import { appColors, appFonts, fontSize } from "../../appTheme";

export const preferenceSettingStyle = StyleSheet.create({
    skuMainView: {
        paddingHorizontal: 15,
        paddingVertical: 10,
        rowGap: 10,
        overflow: "hidden"
    },
    skuSubView: {
        flexDirection: 'row', justifyContent: 'space-between',
    },
    skuTextView: {
        color: appColors.lightDark, fontFamily: appFonts.medium, fontSize: fontSize.smallFontSize, maxWidth: "85%"
    },
})